import Axios, * as others from 'axios';
import URL from '../../Environment';
import IMGPATHS from '../../ImgPaths';
import React, { Component,useEffect, useState } from "react";
import './advertise.css';
import { format } from "date-fns";
import { useParams } from "react-router-dom";
import { Link } from 'react-router-dom';
// import GLightbox from 'glightbox';
// import 'glightbox/dist/css/glightbox.min.css';

const AdvertiseDetail = () => {
  const { id } = useParams();
  const [AdvertiseData, setAdvertiseData] = useState([]);
  const [AdvertiseLoan, setAdvertiseLoading] = useState(true);
  const [errorAdvertise, setAdvertiseError] = useState(null);
  const [AdvertiseDetailData, setAdvertiseDetailData] = useState([]);
  const [AdvertiseDetailLoan, setAdvertiseDetailLoading] = useState(true);
  const [errorAdvertiseDetail, setAdvertiseDetailError] = useState(null);

  console.log(id);

  useEffect(() => {

    // const lightbox = GLightbox({
    //   selector: ".glightbox",
    //   touchNavigation: true,
    //   loop: true,
    //   closeButton: true,
    //   autoplayVideos: true,
    // });

    const fetchAdvertiseData = async () => {

          Axios.get(URL + `api/Advertise/GetAdvertiseDetails?id=${id}`).then((response) => {
            const res = response.data;
            console.log(res);
    
            setAdvertiseData(response.data);
            setAdvertiseLoading(false);   
    
          }).catch((error) => {
            setAdvertiseError(error);
            setAdvertiseLoading(false); 
    
          });
    };
    
    const fetchAdvertiseImageData = async () => {

      try {
        const response = await Axios.post(URL + 'api/Advertise/GetAdvertiseDetailsImage', {
          id: id,
        });
  
        console.log(response);
        setAdvertiseDetailData(response.data);
        setAdvertiseDetailLoading(false); 

      } catch (err) {
        console.log(err);
        setAdvertiseDetailError(error);
        setAdvertiseDetailLoading(false); 

      }

      // Axios.get(URL + `api/Advertise/GetAdvertiseDetailsImage?id=${id}`).then((response) => {
      //   const res = response.data;
      //   console.log(res);

      //   setAdvertiseDetailData(response.data);
      //   setAdvertiseDetailLoading(false);   

      // }).catch((error) => {
      //   setAdvertiseDetailError(error);
      //   setAdvertiseDetailLoading(false); 

      // });
  };

    // เรียกใช้งาน fetchData เมื่อค่าตัวแปร count มีการเปลี่ยนแปลง
    fetchAdvertiseData();
    fetchAdvertiseImageData();


    // Cleanup function ที่จะถูกเรียกเมื่อ component ถูก unmount
    return () => {
      // ทำการคืนการทำงานที่ต้องการ (cleanup)
      //lightbox.destroy();
      //console.log('Component unmounted');
    };



  }, []);

  if (AdvertiseLoan) {
      return <div>Loading...</div>;
  }

  if (errorAdvertise) {
      return <div>Error: {errorAdvertise.message}</div>;
  }

  if (AdvertiseDetailLoan) {
    return <div>Loading...</div>;
  }

  if (errorAdvertiseDetail) {
      return <div>Error: {errorAdvertiseDetail.message}</div>;
  }

  return (
    <div>
      <section className="breadcrumbs">
        <div className="container">
          <div className="row">
            <div className="col-sm-6 a-breadcrumbs" style={{color: '#ffffff'}}>
              <Link to="/home" className="a-breadcrumbs">หน้าแรก</Link>&nbsp;
              <i className="fa fa-angle-right" />&nbsp;<a href="advertise" className="a-breadcrumbs">ข่าวประชาสัมพันธ์</a>
            </div>
          </div>
        </div>
      </section>

      <div className="col-lg-12">
          <section id="blog-details" className="blog-details section">
          <div className="container section-title">
            <h2>ข่าวประชาสัมพันธ์</h2>
          </div>
            <div className="container">
              <article className="article">
                
                {
                  AdvertiseData.map((act) => (
                  
                  <div key={act.id}>
                    <div className="post-img">
                      <img src={`${IMGPATHS}` + `Img/Advertise/${act.id}/${act.img}`} alt className="img-fluid" 
                      style={{
                        height: '900px',
                        width: 'auto',
                        objectFit: 'contain' // หรือ 'cover' ขึ้นอยู่กับผลลัพธ์ที่ต้องการ
                      }} />
                    </div>
                      <h2 key={act.id} className="title">{act.topic}</h2>
                    {/* <div className="meta-top">
                      <ul>
                        <li className="d-flex align-items-center"><i className="bi bi-person" /> <a href="#" style={{fontSize:'20px'}}>{act.update_by}</a></li>
                        <li className="d-flex align-items-center"><i className="bi bi-clock" /> <a href="#" style={{fontSize:'20px'}}>{format(new Date(act.update_day), "d MMMM, yyyy")}</a></li>
                      </ul>
                    </div> */}
                    <div className="content">
                      <p style={{fontSize:'20px'}}>
                        {/* {act.description} */}
                        <div 
                          className="loan-detail-content"
                          style={{fontSize:'20px', whiteSpace: 'pre-wrap'}}
                          dangerouslySetInnerHTML={{ __html: act.description }}
                        />
                      </p>
                      <p style={{fontSize:'20px'}}><a href={act.link} target='_blank' className="stretched-link">{act.linkDesc}</a></p>
                      <p style={{fontSize:'20px'}}><a href={`${IMGPATHS}` + `Form/Advertise/${act.id}/${act.Attachfile}`} target='_blank' className="stretched-link">{act.Attachfile}</a></p>
                    </div>
                  </div>
                  ))
                }

              </article>
            </div>
          </section>

          <section id="services" className="services section">
            <div className="container" >
              <div className="row gy-5">

              {
                AdvertiseDetailData.map((act) => (
                  <div key={act.id} className="col-xl-4 col-md-6">
                    <div className="service-item">
                      <div className="img">
                        <img src={`${IMGPATHS}` + `Img/Advertise/${act.advertise_id}/${act.img_name}`} className="img-fluid" alt={act.img_desc} />
                          
                      </div>
                      <div className="details position-relative">
                          <a href={`${IMGPATHS}` + `Img/Advertise/${act.advertise_id}/${act.img_name}`} target='_blank' className="stretched-link">
                          {act.img_desc !== null && act.img_desc !== "" ? <p style={{fontSize:'20px', color:'#0ea2bd'}}>{act.img_desc}</p> : <p style={{fontSize:'20px', color:'#0ea2bd'}}>Read</p>}
                          </a>
                        </div>
                      </div>
                  </div>

                  ))
                }
                    
              </div>
            </div>
          </section>

        </div>
    </div>
  );
}

export default AdvertiseDetail;
